import {
  SET_IMPORT_DIALOG,
  SET_LOADING,
  SET_COURSE_LOG,
  SET_ACTIVE_PROGRAM
} from './constants';
import { calcProgram } from '../functions/calcProgram';

export const mutations = {
  [SET_IMPORT_DIALOG](state, payload) {
    state.importDialog = payload;
  },
  [SET_LOADING](state, payload) {
    state.loading = payload;
  },
  [SET_COURSE_LOG](state, payload) {
    state.courseLog = payload.map(v => ({
      semester: v.semester,
      no: v.no,
      name: v.name,
      credit: v.credit,
      isPassed: /[DEX]/.test(v.grade) ? '未及格' : /[ABC]+?/.test(v.grade) ? '及格' : v.grade
    }));
    state.programs = calcProgram(state.courseLog.filter(v => /^(及格|成績未到)$/.test(v.isPassed)).map(v => v.semester + v.no));
    localStorage.setItem('courseLog', JSON.stringify(state.courseLog));
  },
  [SET_ACTIVE_PROGRAM](state, payload) {
    state.activeProgram = payload;
    localStorage.setItem('activeProgram', payload);
  },
};